import { styleOverrides } from "./styleOverrides";

const MuiAlert = {
  styleOverrides,
};

export { MuiAlert };
